export default {
  CONTENT_API: '//content.api.dev.dice-tools.com/',
  OP_API: '//op.api.dev.dice-tools.com/',
  ERP_API: '//erp.api.dev.dice-tools.com/',
  CUSTOMER_API: '//customer-contact.api.dev.dice-tools.com/',
  ACCOUNTS_API: '//accounts.api.dev.dice-tools.com/',
  SUBSCRIPTIONS_API: '//subscriptions.api.dev.dice-tools.com/',
  IAM_API: '//iam.api.dev.dice-tools.com/',
  DPMM_API: '//dpmm.api.dev.dice-tools.com/',
  SALESFORCE_NA: '//doosan-nao--nauat.sandbox.my.site.com/dealernet/',
  SALESFORCE_EMEA: '//doosanbobcateu--uat.sandbox.my.site.com/bobcat/',
  MAGNOLIA_AUTHOR: '//magnolia-cms.dev.dice-tools.com/',
  MAGNOLIA_PUBLIC: '//magnolia-public.dev.dice-tools.com/',
  NGPASSPORT_API: '//adminenigma.api.dev.dice-tools.com/',
  SERVICE_AI: '//service-ai-v2-session-api-dev.gdsqa.dice-tools.com/',
  AGENT_AI: '//bedrock-agentcore.us-east-1.amazonaws.com/runtimes/serviceaiv2chat_dev-UzhqA2FMMb/invocations?accountId=474668383292&qualifier=stable'
}
